export default {
  description: state => state.description,
  products: state => state.products,
  productsCount: state => state.total
};